import Vue from 'vue'
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { setTimeout } from 'timers';

export {
    vSelectCellEditor,
    optionsBunchCellEditor,
    optionsBunchCellRenderer,
    vSelectCellRenderer,
    dateCellEditor
}


const vSelectCellEditor = Vue.extend({
    template: `<v-select 
        :options="dropDownValues" 
        v-model="selectedValue" 
        :getOptionLabel="getOptionLabel"
        taggable 
        push-tags
        @search="onSearch"
        @input="onInput"
        :class="{'loadingData':loadingData}"
        >
    </v-select>`,

    props: [
        'options',
        'valueColumn',
        'taggable',
        'labelColumn',
        'searchableColumns',
        'outDataColumns'
    ],

    components: {
        'v-select': VueSelect
    },

    data() {
        return {
            dropDownValues: [],
            selectedValue: null,
            value: "value",
            label: "label",
            searchable: null,
            loadingData: false
        }
    },
    created() {
        if (!this.params.optionsSearchFunction) {
            this.dropDownValues = this.params.options;
        } else {
            this.optionsSearchFunction = this.params.optionsSearchFunction;
        }

        this.fieldName = this.params.colDef.field;
        this.editingRow = this.params.data;

        this.value = this.params.valueColumn || 'value';
        this.label = this.params.labelColumn || 'label';
        this.searchable = this.params.searchableColumns || this.label;
        this.outData = this.params.outDataColumns;
        this.isLocal = this.params.remoteFilter === false || !this.optionsSearchFunction;
        this.selectedValue = null;
        
        // Tenta encontrar e atribuir o valor da célula ao selectedValue
        if (this.params.value != null) {
            const key = this.value;
            const val = this.params.value;

            // Tenta encontrar o item correspondente na lista inicial (caso seja local)
            const fromList = (this.dropDownValues || []).find(opt => opt[key] === val || opt.value === val);

            if (fromList) {
                this.selectedValue = fromList;
            } else if (this.isLocal) {
                // Se não encontrou, tenta pegar dos dados da linha (fallback)
                const localVal = this._getLocalVal();
                if (localVal) this.selectedValue = localVal;
            } else {
                // Para casos remotos, define como objeto "label apenas"
                this.selectedValue = { [this.label]: val };
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.$children[0].toggleDropdown({ preventDefault: () => {} })
            if(!this.optionsSearchFunction && this.dropDownValues.length){
                this.fixDropDownPosition(this.dropDownValues.length);
            }
        }, 200);
        if (this.params.optionsSearchFunction) {
            this.onSearch("");
            this.remoteFilter = this.params.remoteFilter;
        }
    },
    methods: {
        setLoading(state) {
            this.loadingData = state;
        },
        _getLocalVal(){
            const fieldName = this.params.column.colId;
            const valKey = (this.value !== 'value' && this.value) || fieldName; 
            const keyVal = this.editingRow[valKey] || this.editingRow[fieldName + "_key"];
            if(this.editingRow.hasOwnProperty(valKey) && keyVal){
                let lookUpValue = (this.dropDownValues || []).
                                    find(e => e[valKey] === keyVal || e.value === keyVal);
                return {...lookUpValue, [valKey]: keyVal};
            } else {
                return false;
            }
        },
        /**
         * Method that return correctly value to the 
         * grid component.
         */
        getValue() {
            let lookUpValue = {...(this.selectedValue || (this.isLocal && this._getLocalVal()) || this.editingRow)};

            if (lookUpValue && lookUpValue.hasOwnProperty(this.value)) {
                this.editingRow[this.fieldName + '_key'] = lookUpValue[this.value];

                let toReturnLabel = [];
                if (Array.isArray(this.label)) {
                    this.label.forEach(lbl => {
                        toReturnLabel.push(lookUpValue[lbl]);
                    });

                    toReturnLabel = toReturnLabel.join(' - ');
                } else if (this.label) {
                    toReturnLabel = lookUpValue[this.label];
                }

                this.computeOutData(lookUpValue);
                return toReturnLabel;

            } else if (this.params.taggable) {

                this.editingRow[this.fieldName + '_key'] = null;
                this.editingRow[this.fieldName + '_tagged'] = true;

                return this.selectedValue[this.label];
            }

            return null;
        },

        /**
         * On Search event handler. Chage dropdown
         * values according to search text.
         * 
         * @param {String} value 
         */
        onSearch: function (value) {
            if (this.optionsSearchFunction && this.remoteFilter !== false) {
                let promise = this.optionsSearchFunction(value);
                this.setLoading(true);

                if (promise && promise.then) {
                    promise.then((res) => {
                        this.dropDownValues = res;
                        this.setLoading(false);
                        this.fixDropDownPosition(res.length);
                    });
                } else {
                    console.warn("the provided options search function is not a thenable");
                }
            }
        },

        /**
         * Format option labels to show in
         * dropdown.
         * 
         * @param {Object} option 
         */
        getOptionLabel(option) {
            if (Array.isArray(this.searchable)) {
                let toReturnLabel = [];

                this.searchable.forEach(lbl => {
                    toReturnLabel.push(option[lbl]);
                });

                return toReturnLabel.join(' - ');

            } else if (this.searchable) {
                return option[this.searchable];
            }
        },

        /**
         * Stop editing after v-select value changes.
         * Jump to the next editable cell on line.
         */
        onInput() {
            this.params.api.stopEditing();
            this.params.jumpNextEditableCell(this.params.rowIndex, this.params.colDef.field);
        },

        /**
         * Put into current editing row, values correspondent
         * to 'outData' property from colDef.
         * 
         * using the field name in the outData property will cause 
         * an error upon computing the value change because outData  
         * will cause a side-effect in the value object holder
         * @param {Object} selectedValue 
         */
        computeOutData(selectedValue) {
            if (this.outData) {
                if (Array.isArray(this.outData)) {
                    this.outData.forEach(colName => {
                        this.editingRow[colName] = selectedValue[colName];
                    });
                } else {
                    console.error(`Incorrect type for 'outData' property`);
                }
            }
        },
        fixDropDownPosition(optionCount) {
            let parentRect = this.$parent.$el.getBoundingClientRect();
            let rect = this.$el.getBoundingClientRect();
            optionCount = optionCount > 9 ? 9 : optionCount;
            let dropDownSize = ((optionCount * 23) + 10); // optionCount * optionHeight + padding
            let willFitInBottom = parentRect.bottom > (rect.bottom + dropDownSize);
            let bottomOverflow = (rect.bottom + dropDownSize + 26) - parentRect.bottom;
            let topOverflow = parentRect.top + 26 - (rect.top - dropDownSize);
            if (!willFitInBottom && topOverflow < bottomOverflow) {
                this.$el.parentElement.classList.add("open-select-above");
                this.dropDownValues = [...(this.dropDownValues || [])].reverse();
            } else if (this.$el.parentElement && this.$el.parentElement.classList.contains("open-select-above")) {
                this.$el.parentElement.classList.remove("open-select-above");
                this.dropDownValues = [...(this.dropDownValues || [])].reverse();
            }
            if (bottomOverflow > 0 && topOverflow > 0) {
                setTimeout(function () {
                    let dropdownElement = this.$el.querySelector(".vs__dropdown-menu");
                    if(dropdownElement)
                        dropdownElement.style.height = `${dropDownSize - Math.min(bottomOverflow, topOverflow)}.px`;
                }.bind(this), 200)
            }
        },
    }
});

const optionsBunchCellEditor = Vue.extend({
    template: `<div @click="rotateOption" class="options-bunch-cell-editor" v-html="bunchOptions[optionsKeys[currentOption]]"></div>`,
    props: [
        'options'
    ],

    data() {
        return {
            currentOption: null,
            bunchOptions: {},
            optionsKeys: []
        }
    },
    created() {
        this.bunchOptions = this.params.options;
        this.optionsKeys = Object.keys(this.bunchOptions);
        this.currentOption = 0;

        this.fieldName = this.params.colDef.field;
        this.editingRow = this.params.data;
    },
    methods: {
        rotateOption() {
            if (this.currentOption == this.optionsKeys.length - 1) {
                this.currentOption = 0;
            } else {
                this.currentOption++;
            }
        },
        getValue() {
            let toReturnValue = this.bunchOptions[this.optionsKeys[this.currentOption]];
            this.editingRow[this.fieldName + "_key"] = this.optionsKeys[this.currentOption];
            return toReturnValue;
        }
    }
});

var optionsBunchCellRenderer = function () {
    this.eGui = document.createElement("span");
}

optionsBunchCellRenderer.prototype.init = function (params) {
    this.rendererImage = params.rendererImage;
    this.value = params.value;
    this.updateImages();
};
optionsBunchCellRenderer.prototype.updateImages = function () {
    this.eGui.innerHTML = this.value || '';
};
optionsBunchCellRenderer.prototype.getGui = function getGui() {
    return this.eGui;
};
optionsBunchCellRenderer.prototype.refresh = function (params) {
    this.value = params.value;

    this.eGui.innerHTML = '';
    this.updateImages();
};

var vSelectCellRenderer = function () {
    this.eGui = document.createElement("span");
}

vSelectCellRenderer.prototype.init = function (params) {
    let options = params.colDef.cellEditorParams.options;
    let valueColumn = params.colDef.cellEditorParams.valueColumn || 'value';
    let labelColumn = params.colDef.cellEditorParams.labelColumn || 'label';

    if (options && Array.isArray(options)) {
        let selectedOption = options.find(opt => opt[valueColumn] == params.value);
        this.value = selectedOption && selectedOption[labelColumn];
    } else {
        this.value = params.value;
    }

    this.updateImages();
};
vSelectCellRenderer.prototype.updateImages = function () {
    this.eGui.innerHTML = this.value || '';
};
vSelectCellRenderer.prototype.getGui = function getGui() {
    return this.eGui;
};
vSelectCellRenderer.prototype.refresh = function (params) {
    this.value = params.value;

    this.eGui.innerHTML = '';
    this.updateImages();
};


const dateCellEditor = Vue.extend({
    template: `
        <div :ref="'root'">
            <input type="date" v-model="inputValue" :ref="'input'"/>
        </div>
    `,
    data(){
        return {
            inputValue: null
        }
    },
    created() {
        if(this.params.value){
            const [day, month, year] = this.params.value.split('/');
            this.inputValue = `${year}-${month}-${day}`;
        }
    },
    mounted(){
        //todo: remove setTimeout
        setTimeout(() => {
            this.$refs.input.focus();
        }, 1);
    },
    methods: {
        rotateOption() {
            if (this.currentOption == this.optionsKeys.length - 1) {
                this.currentOption = 0;
            } else {
                this.currentOption++;
            }
        },
        getValue() {
            if(this.inputValue && this.inputValue.length){
                const [year, month, day] = this.inputValue.split('-');
                return `${day}/${month}/${year}`;
            }
            return null
        }
    }
});